import { useLocation } from "react-router";
import { useEffect } from "react";
import posthog from "posthog-js";

export function PostHogPageView() {
  const location = useLocation();

  useEffect(() => {
    const capture = () => {
      if (location && posthog.__loaded) {
        posthog.capture('$pageview', {
          $current_url: window.location.href,
          page_path: location.pathname
        });
      }
    };

    capture();

    // If not loaded yet, retry when it is
    if (!posthog.__loaded) {
      const interval = setInterval(() => {
        if (posthog.__loaded) {
          capture();
          clearInterval(interval);
        }
      }, 500);
      return () => clearInterval(interval);
    }
  }, [location]);

  return null;
}
